<template>
    <div>
        <barraprincipaladmin @abrir="mtMenuVisible"> </barraprincipaladmin>
        <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>

        <v-container fluid>

             <div class="claro elevation-5">
                <v-row dense>
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Prestadores de servicios profesionales.</h2>
                    </v-col>
                </v-row>
            </div>

            <br>

            <v-row>
                <v-col cols="12" md="12">
                    <div class="mx-0">
                        <v-data-table
                            dense
                            :headers="tabla_encabezado"
                            :items="prestadores"
                            :item-class="color_fondo"
                            :items-per-page="-1"
                            class="elevation-1"
                            mobile-breakpoint="100"
                            multi-sort
                            :search="busqueda"
                            loading-text="Consultando información..."
                            :loading="cargando"
                            no-data-text="No se encontró información."
                            locale="es-MX"
                            :footer-props="{
                                'items-per-page-text':'Elementos por página',
                                'items-per-page-all-text': 'Todos',
                                'show-current-page':true,
                                'show-first-last-page': true,
                                'page-text':page_text
                            }"
                            @pagination="texto_paginacion"
                        >

                        <!-- Acciones -->
                        <template v-slot:item.acciones="{ item }">
                            <div class="d-flex justify-end">
                                <v-btn  icon color="primary" @click="verDetallePSP(item)"><v-icon>mdi-information-outline</v-icon></v-btn>
                            </div>
                        </template>


                        </v-data-table>
                    </div>
                </v-col>
            </v-row>


            <v-dialog v-if="dlgpspdetalle" v-model="dlgpspdetalle" max-width="1200">
                <v-card>
                    <v-card-title class="d-flex justify-center primary--text">
                        <v-row>
                           <v-col cols="12" class="d-flex justify-center">Detalle de prestador de servicios</v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="1" class="primary--text">Nombre:</v-col>
                            <v-col cols="12" sm="12" md="11" class="black--text">{{pspdetalle.nombre}} {{pspdetalle.apellido_paterno}} {{pspdetalle.apellido_materno}}</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="1"  class="primary--text">Direcció:</v-col>
                            <v-col cols="12" sm="12" md="7" class="black--text">{{pspdetalle.direccion_calle}} {{pspdetalle.direccion_numero}}, {{pspdetalle.direccion_colonia}}, {{pspdetalle.direccion_ciudad}}</v-col>

                            <v-col cols="12" sm="12" md="1"  class="primary--text">Teléfono:</v-col>
                            <v-col cols="12" sm="12" md="3" class="black--text">{{pspdetalle.telefono}}</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="2"  class="primary--text">Tipo de contrato:</v-col>
                            <v-col cols="12" sm="12" md="7" class="black--text" v-if="pspdetalle.tipo_contrato == 'asimilados'" >ASIMILADO</v-col>
                            <v-col cols="12" sm="12" md="7" class="black--text" v-if="pspdetalle.tipo_contrato == 'honorarios'">POR HONORARIOS</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="1" class="primary--text">RFC:</v-col>
                            <v-col cols="12" sm="12" md="11" class="black--text">{{pspdetalle.rfc}} </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="1" class="primary--text">CURP:</v-col>
                            <v-col cols="12" sm="12" md="11" class="black--text">{{pspdetalle.curp}} </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="1"  class="primary--text">Banco:</v-col>
                            <v-col cols="12" sm="12" md="2" class="black--text">{{pspdetalle.banco_nombre}}</v-col>

                            <v-col cols="12" sm="12" md="1"  class="primary--text">Sucursal:</v-col>
                            <v-col cols="12" sm="12" md="2" class="black--text">{{pspdetalle.banco_sucursal}}</v-col>

                            <v-col cols="12" sm="12" md="1"  class="primary--text">No. Cuenta:</v-col>
                            <v-col cols="12" sm="12" md="2" class="black--text">{{pspdetalle.banco_cuenta}}</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="2"  class="primary--text">Cuenta CLABE:</v-col>
                            <v-col cols="12" sm="12" md="2" class="black--text">{{pspdetalle.banco_clabe}}</v-col>

                            <v-col cols="12" sm="12" md="1"  class="primary--text">No. Tarjeta:</v-col>
                            <v-col cols="12" sm="12" md="2" class="black--text">{{pspdetalle.banco_tarjeta}}</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="2"  class="primary--text">Tipo personal:</v-col>
                            <v-col cols="12" sm="12" md="2" class="black--text">{{pspdetalle.tipo_personal}}</v-col>
                        </v-row>


                        <v-row>
                            <v-col cols="12" class="primary--text font-weight-bold">Documentos generales</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols='12' sm="12" md="2" class="font-weight-bold">CURP</v-col>
                            <v-col cols='12' sm="12" md="10">
                                <v-icon v-if="pspdetalle.curp_comprobante == 0 || pspdetalle.curp_comprobante == 3" color="error">mdi-file-document-remove-outline</v-icon>
                                <v-icon v-if="pspdetalle.curp_comprobante != 0 && pspdetalle.curp_comprobante != 3" @click="descargarArchivo(pspdetalle.cprestador, 'curp_comprobante')" color="primary">mdi-file-download-outline</v-icon>
                                <v-icon v-if="pspdetalle.curp_comprobante == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'curp_comprobante', 2)"  class="ml-4" color="success">mdi-thumb-up</v-icon>
                                <v-icon v-if="pspdetalle.curp_comprobante == 1 || pspdetalle.curp_comprobante == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'curp_comprobante', 3)" class="ml-4" color="error">mdi-thumb-down</v-icon>
                            </v-col>

                            <v-col cols='12' sm="12" md="2" class="font-weight-bold">Comprobante domicilio</v-col>
                            <v-col cols='12' sm="12" md="10">
                                <v-icon v-if="pspdetalle.direccion_comprobante == 0 || pspdetalle.direccion_comprobante == 3" color="error">mdi-file-document-remove-outline</v-icon>
                                <v-icon v-if="pspdetalle.direccion_comprobante != 0 && pspdetalle.direccion_comprobante != 3" @click="descargarArchivo(pspdetalle.cprestador, 'direccion_comprobante')" color="primary">mdi-file-download-outline</v-icon>
                                <v-icon v-if="pspdetalle.direccion_comprobante == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'direccion_comprobante', 2)"  class="ml-4" color="success">mdi-thumb-up</v-icon>
                                <v-icon v-if="pspdetalle.direccion_comprobante == 1 || pspdetalle.direccion_comprobante == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'direccion_comprobante', 3)" class="ml-4" color="error">mdi-thumb-down</v-icon>
                            </v-col>

                            <v-col cols='12' sm="12" md="2" class="font-weight-bold" v-if="pspdetalle.tipo_contrato=='honorarios' || pspdetalle.tipo_contrato == null">RFC</v-col>
                            <v-col cols='12' sm="12" md="2" class="font-weight-bold" v-if="pspdetalle.tipo_contrato=='asimilados'">Último talon de pago</v-col>
                            <v-col cols='12' sm="12" md="10">
                                <v-icon v-if="pspdetalle.rfc_comprobante == 0 || pspdetalle.rfc_comprobante == 3" color="error">mdi-file-document-remove-outline</v-icon>
                                <v-icon v-if="pspdetalle.rfc_comprobante != 0 && pspdetalle.rfc_comprobante != 3" @click="descargarArchivo(pspdetalle.cprestador, 'rfc_comprobante')" color="primary">mdi-file-download-outline</v-icon>
                                <v-icon v-if="pspdetalle.rfc_comprobante == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'rfc_comprobante', 2)"  class="ml-4" color="success">mdi-thumb-up</v-icon>
                                <v-icon v-if="pspdetalle.rfc_comprobante == 1 || pspdetalle.rfc_comprobante == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'rfc_comprobante', 3)" class="ml-4" color="error">mdi-thumb-down</v-icon>
                            </v-col>

                            <v-col cols='12' sm="12" md="2" class="font-weight-bold">Datos bancarios</v-col>
                            <v-col cols='12' sm="12" md="10">
                                <v-icon v-if="pspdetalle.banco_caratula == 0 || pspdetalle.banco_caratula == 3" color="error">mdi-file-document-remove-outline</v-icon>
                                <v-icon v-if="pspdetalle.banco_caratula != 0 && pspdetalle.banco_caratula != 3" @click="descargarArchivo(pspdetalle.cprestador, 'banco_caratula')" color="primary">mdi-file-download-outline</v-icon>
                                <v-icon v-if="pspdetalle.banco_caratula == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'banco_caratula', 2)"  class="ml-4" color="success">mdi-thumb-up</v-icon>
                                <v-icon v-if="pspdetalle.banco_caratula == 1 || pspdetalle.banco_caratula == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'banco_caratula', 3)" class="ml-4" color="error">mdi-thumb-down</v-icon>
                            </v-col>
                        </v-row>


                        <v-row>
                            <v-col cols="12" class="primary--text font-weight-bold">Documentos académicos</v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="12" md="4" >
                                <span class="font-weight-bold">Licenciatura</span>                                
                                <div>
                                    <span class="pl-6 mr-6">Certificado</span>
                                    <v-icon color='error' v-if="pspdetalle.lic_certificado == 0 || pspdetalle.lic_certificado == 3" >mdi-file-document-remove-outline</v-icon>    
                                    <v-icon color='primary' v-if="pspdetalle.lic_certificado != 0 && pspdetalle.lic_certificado != 3" @click="descargarArchivo(pspdetalle.cprestador, 'lic_certificado')">mdi-file-download-outline</v-icon>    
                                    <v-icon class="ml-4" v-if="pspdetalle.lic_certificado == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'lic_certificado', 2)" color="success">mdi-thumb-up</v-icon>                                
                                    <v-icon class="ml-4" v-if="pspdetalle.lic_certificado == 1 || pspdetalle.lic_certificado == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'lic_certificado', 3)" color="error">mdi-thumb-down</v-icon>                                
                                </div>
                                <div>
                                    <span class="pl-6 mr-13">Cédula</span>
                                    <v-icon color='error' v-if="pspdetalle.lic_cedula == 0 || pspdetalle.lic_cedula == 3" >mdi-file-document-remove-outline</v-icon>    
                                    <v-icon color='primary' v-if="pspdetalle.lic_cedula != 0 && pspdetalle.lic_cedula != 3" @click="descargarArchivo(pspdetalle.cprestador, 'lic_cedula')">mdi-file-download-outline</v-icon>    
                                    <v-icon class="ml-4" v-if="pspdetalle.lic_cedula == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'lic_cedula', 2)" color="success">mdi-thumb-up</v-icon>                                
                                    <v-icon class="ml-4" v-if="pspdetalle.lic_cedula == 1 || pspdetalle.lic_cedula == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'lic_cedula', 3)" color="error">mdi-thumb-down</v-icon>                                
                                </div>
                            </v-col>

                            <v-col cols="12" sm="12" md="4" >
                                <span class="font-weight-bold">Maestría</span>                                
                                <div>
                                    <span class="pl-6 mr-6">Certificado</span>
                                    <v-icon color='error' v-if="pspdetalle.mae_certificado == 0 || pspdetalle.mae_certificado == 3" >mdi-file-document-remove-outline</v-icon>    
                                    <v-icon color='primary' v-if="pspdetalle.mae_certificado != 0 && pspdetalle.mae_certificado != 3" @click="descargarArchivo(pspdetalle.cprestador, 'mae_certificado')">mdi-file-download-outline</v-icon>    
                                    <v-icon class="ml-4" v-if="pspdetalle.mae_certificado == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'mae_certificado', 2)" color="success">mdi-thumb-up</v-icon>                                
                                    <v-icon class="ml-4" v-if="pspdetalle.mae_certificado == 1 || pspdetalle.mae_certificado == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'mae_certificado', 3)" color="error">mdi-thumb-down</v-icon>                                
                                </div>
                                <div>
                                    <span class="pl-6 mr-13">Cédula</span>
                                    <v-icon color='error' v-if="pspdetalle.mae_cedula == 0 || pspdetalle.mae_cedula == 3" >mdi-file-document-remove-outline</v-icon>    
                                    <v-icon color='primary' v-if="pspdetalle.mae_cedula != 0 && pspdetalle.mae_cedula != 3" @click="descargarArchivo(pspdetalle.cprestador, 'mae_cedula')">mdi-file-download-outline</v-icon>    
                                    <v-icon class="ml-4" v-if="pspdetalle.mae_cedula == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'mae_cedula', 2)" color="success">mdi-thumb-up</v-icon>                                
                                    <v-icon class="ml-4" v-if="pspdetalle.mae_cedula == 1 || pspdetalle.mae_cedula == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'mae_cedula', 3)" color="error">mdi-thumb-down</v-icon>                                
                                </div>
                            </v-col>

                            <v-col cols="12" sm="12" md="4" >
                                <span class="font-weight-bold">Doctorado</span>                                
                                <div>
                                    <span class="pl-6 mr-6">Certificado</span>
                                    <v-icon color='error' v-if="pspdetalle.doc_certificado == 0 || pspdetalle.doc_certificado == 3" >mdi-file-document-remove-outline</v-icon>    
                                    <v-icon color='primary' v-if="pspdetalle.doc_certificado != 0 && pspdetalle.doc_certificado != 3" @click="descargarArchivo(pspdetalle.cprestador, 'doc_certificado')">mdi-file-download-outline</v-icon>    
                                    <v-icon class="ml-4" v-if="pspdetalle.doc_certificado == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'doc_certificado', 2)" color="success">mdi-thumb-up</v-icon>                                
                                    <v-icon class="ml-4" v-if="pspdetalle.doc_certificado == 1 || pspdetalle.doc_certificado == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'doc_certificado', 3)" color="error">mdi-thumb-down</v-icon>                                
                                </div>
                                <div>
                                    <span class="pl-6 mr-13">Cédula</span>
                                    <v-icon color='error' v-if="pspdetalle.doc_cedula == 0 || pspdetalle.doc_cedula == 3" >mdi-file-document-remove-outline</v-icon>    
                                    <v-icon color='primary' v-if="pspdetalle.doc_cedula != 0 && pspdetalle.doc_cedula != 3" @click="descargarArchivo(pspdetalle.cprestador, 'doc_cedula')">mdi-file-download-outline</v-icon>    
                                    <v-icon class="ml-4" v-if="pspdetalle.doc_cedula == 1" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'doc_cedula', 2)" color="success">mdi-thumb-up</v-icon>                                
                                    <v-icon class="ml-4" v-if="pspdetalle.doc_cedula == 1 || pspdetalle.doc_cedula == 2" @click="actulizarEstatusDocumento(pspdetalle.cprestador, 'doc_cedula', 3)" color="error">mdi-thumb-down</v-icon>                                
                                </div>
                            </v-col>
                        </v-row>

                    </v-card-text>

                    <v-card-text>
                        <v-row class="d-flex justify-end mt-2">
                            <v-col cols="12" class="d-flex justify-end">
                                <v-btn dark class="ml-2" color="error" @click="dlgpspdetalle = false">Cerrar</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>


            <dialogocargando :visible='dlgcargando' :titulo='dlgcargandotitulo' :descripcion='dlgcargandodescripcion' > </dialogocargando>

            <v-snackbar v-model="snackbar" :color="snackbarcolor" light >
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>

            <dialogoconfirmacion ref="dialogoconfirmacion"></dialogoconfirmacion>

        </v-container>
    </div>
</template>

<script>

import menulateral from "@/components/MenuLateralAdmin";
import barraprincipaladmin from "@/components/BarraPrincipalAdmin";
import dialogocargando from "@/components/DialogoCargando"
import dialogoconfirmacion from "@/components/DialogoConfirmacion"

export default {

    components:{
        menulateral,
        barraprincipaladmin,
        dialogocargando,
        dialogoconfirmacion
    },

    data() {
        return {
            menu_visible: false,
            dlgcargando: false,
            dlgcargandotitulo: '',
            dlgcargandodescripcion: '',
            dlgpspdetalle: false,


            snackbartexto: "",
            snackbar: false,
            snackbarcolor: "",

            busqueda:'',
            tabla_encabezado:[],
            prestadores: [],
            page_text:'',
            cargando:true,

            color_fondo:"blue lighten-4",

            pspdetalle: []
        }
    },

    beforeCreate() {
        const token = sessionStorage.getItem('datax')

        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})
            .then((response)=>{

                const data = response.data

                if(data.codigo == 'lgout')
                    this.$router.push({"name":'AdminLogin'})

            })
            .catch((error)=>{
                console.log("Error "+error);
            })
    },

    created() {
        this.getInformacion()
    },

    methods: {
        mtMenuVisible(value){
            this.menu_visible = value
        },

        texto_paginacion: function(pg){
            this.page_text = 'Total elementos '+pg.itemsLength
        },

        getInformacion(){
            const token = sessionStorage.getItem('datax')


            this.dlgcargandotitulo = 'Consultando información',
            this.dlgcargandodescripcion = 'Espere un momento',

            this.cargando = true
            this.axios.get(this.$url+'/admin/psp/listado', {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        //Encabezados de la tabla
                        for(let key in data.prestadores[0])
                            this.tabla_encabezado.push({
                                text:key.toUpperCase(),
                                value:key,
                                class:"black--text"
                            })
                        //Agrego la columna de acciones a la tabla
                        this.tabla_encabezado.push({
                            text:"ACCIONES",
                            value:"acciones",
                            class:"black--text"
                        })

                        this.prestadores = data.prestadores
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }
                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        verDetallePSP(item){
            const token = sessionStorage.getItem('datax')

            this.dlgcargandotitulo = 'Consultando información',
            this.dlgcargandodescripcion = 'Espere un momento',

            this.dlgcargando = true
            this.axios.get(this.$url+'/admin/psp/informacion/'+item.id, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if (!data.error) {
                        this.pspdetalle = data.perfil
                        console.log(data.perfil);
                        this.dlgpspdetalle = true
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'error'
                        this.snackbar = true
                    }
                })
                .catch((error)=>{
                    console.log(error);
                    this.snackbartexto = "Ocurrió un error, intente nuevamente"
                    this.snackbarcolor = 'error'
                    this.snackbar = true
                })
                .finally(()=>{
                    this.dlgcargando = false
                })
        },

        async actulizarEstatusDocumento(idpsp, documento, estatus){

            let confirmacion = false

            if(estatus == 2){
                confirmacion = await this.$refs.dialogoconfirmacion.abrir({
                    titulo: '¿Realmente quiere aceptar el archivo?',
                    confirmar: 'Si',
                    cancelar: 'No'
                })
            }
            if(estatus == 3){
                confirmacion = await this.$refs.dialogoconfirmacion.abrir({
                    titulo: '¿Realmente quiere rechazar el archivo?',
                    confirmar: 'Si',
                    cancelar: 'No'
                })
            }

            if(!confirmacion){
                return
            }

            const token = sessionStorage.getItem('datax')

            const datos = {
                idpsp: idpsp,
                documento: documento,
                estatus: estatus
            }

            this.dlgcargandotitulo = 'Actualizando documento',
            this.dlgcargandodescripcion = 'Espere un momento',
            this.dlgcargando = true

            this.axios.post(this.$url+'/admin/psp/documento/actualizaestatus', {datos:datos}, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data =  response.data
                    if(!data.error){
                        this.snackbar = true
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'success'

                        this.actualizaEstatusDocumentoLocal(documento, estatus)

                    }
                    else{
                        this.snackbar = true
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'error'
                    }
                })
                .catch((error)=>{
                    console.log("Error al actualizar documento "+error);
                    this.snackbar = true
                    this.snackbartexto = "Error al actualizar documento."
                    this.snackbarcolor = 'error'
                })
                .finally(()=>{
                    this.dlgcargando = false
                })


        },

        actualizaEstatusDocumentoLocal(documento, estatus){

            console.log(this.pspdetalle.curp_comprobante);

            if(documento == 'curp_comprobante')
                this.pspdetalle.curp_comprobante = estatus
            if(documento == 'rfc_comprobante')
                this.pspdetalle.rfc_comprobante = estatus
            if(documento == 'direccion_comprobante')
                this.pspdetalle.direccion_comprobante = estatus
            if(documento == 'banco_caratula')
                this.pspdetalle.banco_caratula = estatus
            if(documento == 'lic_certificado')
                this.pspdetalle.lic_certificado = estatus
            if(documento == 'lic_cedula')
                this.pspdetalle.lic_cedula = estatus
            if(documento == 'mae_certificado')
                this.pspdetalle.mae_certificado = estatus
            if(documento == 'mae_cedula')
                this.pspdetalle.mae_cedula = estatus
            if(documento == 'doc_certificado')
                this.pspdetalle.doc_certificado = estatus
            if(documento == 'doc_cedula')
                this.pspdetalle.doc_cedula = estatus
            
        },

        descargarArchivo(idpsp, tipo){
            const token = sessionStorage.getItem('datax')
            const data = {
                idpsp: idpsp,
                tipo: tipo
            }

            //Funciona bien en Firefox
            this.axios.post(this.$url+"/admin/psp/archivos/descargar", {data:data},
                    {
                        headers: {Authorization: `Bearer ${token}`},
                        responseType: 'blob'
                    })

                .then((response)=>{

                    if(response.data.error)
                        return

                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)

                })
                .catch((error)=>{
                    console.log("Descarga archivo "+error);
                })
        },

    },
}
</script>

<style>


</style>